// extracted by mini-css-extract-plugin
module.exports = {"prev-next-button":"TimeframeSelector_prev-next-button__qYcz7","rate-label":"TimeframeSelector_rate-label__2j2Zy","rate-description":"TimeframeSelector_rate-description__3jz1L"};